import { Card } from "../components/Card";

const cardImages = {
  menu: { src: "/assets/menu.webp", alt: "Чайник с мятным чаем" },
  market: { src: "/assets/market.webp", alt: "Товары маркета" },
  events: { src: "/assets/events.webp", alt: "Афиша мероприятий" },
  promotions: { src: "/assets/gifts.webp", alt: "Подарок для акций и розыгрышей" },
  "guest-notes": { src: "/assets/notes.webp", alt: "Блокнот заметок" },
};

const dashboardCards = [
  { id: "menu", title: "Меню", variant: "light", inactive: false },
  { id: "market", title: "Маркет", subtitle: "Товары и мерч", variant: "light", inactive: false },
  { id: "events", title: "Мероприятия", subtitle: "Актуальные ивенты", variant: "light", inactive: false },
  {
    id: "promotions",
    title: "Акции и розыгрыши",
    subtitle: "Спецпредложения и призы",
    variant: "light",
    inactive: false,
  },
  {
    id: "guest-notes",
    title: "Заметки",
    subtitle: "Запиши самое главное",
    variant: "light",
    inactive: false,
  },
];

export function Home({
  onOpenEvents,
  onOpenMarket,
  onOpenBonuses,
  onOpenMenu,
  onOpenGuestNotes,
  onOpenPromotions,
}) {
  return (
    <section className="client client--home">
      <div className="homeSurface">
        <div className="cardsGrid cardsGrid--home">
          {dashboardCards.map((card) => (
            <Card
              key={card.id}
              className="card--homeNav"
              variant={card.variant}
              title={card.title}
              subtitle={card.subtitle}
              inactive={card.inactive}
              imageSrc={cardImages[card.id]?.src}
              imageAlt={cardImages[card.id]?.alt ?? ""}
              onClick={
                card.id === "events"
                  ? onOpenEvents
                  : card.id === "market"
                    ? onOpenMarket
                    : card.id === "menu"
                        ? onOpenMenu
                        : card.id === "guest-notes"
                          ? onOpenGuestNotes
                          : card.id === "promotions"
                            ? onOpenPromotions
                      : undefined
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
}
